/**
 * Travel Module - Constants
 * 旅行模块的常量定义
 */

import { TravelPreference, PaymentMode, TravelVisibility } from './types';

/**
 * 旅行偏好选项
 * 这些选项用于用户选择旅行偏好
 */
export const TRAVEL_PREFERENCES: TravelPreference[] = [
  { id: 'culture', labelKey: 'createTravel.preferences.culture', icon: 'museum' },
  { id: 'food', labelKey: 'createTravel.preferences.food', icon: 'restaurant' },
  { id: 'scenery', labelKey: 'createTravel.preferences.scenery', icon: 'landscape' },
  { id: 'history', labelKey: 'createTravel.preferences.history', icon: 'account-balance' },
  { id: 'deep-tour', labelKey: 'createTravel.preferences.deepTour', icon: 'explore' },
  { id: 'checkin', labelKey: 'createTravel.preferences.checkin', icon: 'photo-camera' },
];

/**
 * 支付模式选项
 */
export const PAYMENT_MODES: Array<{ value: PaymentMode; labelKey: string }> = [
  { value: 'prepay_average', labelKey: 'createTravel.paymentModes.prepayAverage' },
  { value: 'postpay_aa', labelKey: 'createTravel.paymentModes.postpayAA' },
  { value: 'postpay_custom', labelKey: 'createTravel.paymentModes.postpayCustom' },
  { value: 'no_payment', labelKey: 'createTravel.paymentModes.noPayment' },
];

/**
 * 可见性选项
 */
export const VISIBILITY_OPTIONS: Array<{ value: TravelVisibility; labelKey: string; icon: string }> = [
  { value: 'public', labelKey: 'createTravel.visibility.public', icon: 'public' },
  { value: 'friends_only', labelKey: 'createTravel.visibility.friendsOnly', icon: 'people' },
  { value: 'private', labelKey: 'createTravel.visibility.private', icon: 'lock' },
];

/**
 * 默认的最小参与人数
 */
export const DEFAULT_MIN_PARTICIPANTS = 2;

/**
 * 默认的最大参与人数
 */
export const DEFAULT_MAX_PARTICIPANTS = 10;

/**
 * AI描述最大长度
 */
export const MAX_AI_DESCRIPTION_LENGTH = 1000;

/**
 * 项目名称最大长度
 */
export const MAX_PROJECT_NAME_LENGTH = 100;

/**
 * 项目描述最大长度
 */
export const MAX_PROJECT_DESCRIPTION_LENGTH = 2000;

/**
 * 预算最小值
 */
export const MIN_BUDGET = 0;

/**
 * 预算最大值
 */
export const MAX_BUDGET = 1000000;
